import { Tooltip } from "@mui/material";

function WithdrawAmount(props) {
  return (
    <div className="col-12 col-md-6 pl-2">
      <div className="card">
        <div className="card-body pt-3">
          <div className="w-100 bg-primary rounded-sm">
            <div
              className="media align-items-center"
              style={{ position: "relative", padding: "15px" }}
            >
              <span className="avatar avatar-xl rounded-circle">
                <img
                  alt="user avatar"
                  src={props.user.avatar}
                  style={{
                    objectFit: "cover",
                    aspectRatio: "1",
                    position: "relative",
                  }}
                />
              </span>
              <div className="ml-3">
                <h3 className="mb-0">{props.user.name}</h3>
                <p className="mb-0">{props.user.latest_role}</p>
              </div>
            </div>
          </div>
          {props.bank?.account_setup_status === 'restricted' && (
            <div className="alert alert-danger mt-3 mb-0" role="alert">
              Funds will be available for withdrawal when account setup is complete.
            </div>
          )}
          <div className="w-100 py-4">
            <h4 className="mb-0 text-gray text-center">Balance</h4>
            <h1 className="mb-0 text-xxl text-center text-dark">
              ${props.bank.balance ?? 0}
            </h1>
          </div>
          <div className="w-100 bg-primary rounded-sm py-2 px-3 pt-4">
            <input
              type="number"
              name="withdrawAmount"
              placeholder="Enter Amount"
              value={props?.withdrawAmount}
              className="w-100 bg-primary withdrawl-input text-center"
              disabled={props?.bank?.bank_account?.status !== "enabled"}
              onChange={(e) => props.setWithdrawAmount(e.target.value)}
            />
            <br />
            <div className="d-center mt-2">
              <Tooltip
                title={
                  !props?.bank?.bank_account?.bank_name && "Link your account"
                }
                placement="right"
                className="w-100"
              >
                <span>
                  <button
                    className="btn btn-default w-100"
                    disabled={
                      !props.bank?.bank_account?.bank_name ||
                      Number(props?.bank?.bank_account?.balance) < 1 ||
                      Number(props?.withdrawAmount) <= 0 ||
                      Number(props?.withdrawAmount) >
                        Number(props?.bank.balance)
                    }
                    onClick={props?.handleWithdraw}
                  >
                    Withdraw
                  </button>
                </span>
              </Tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WithdrawAmount;
